// extracted by mini-css-extract-plugin
export default {"icon":"SizeRecIcon-module-icon-agW2a","scale":"SizeRecIcon-module-scale-EJHyg"};